/**
 * Picks the app language from the browser's preference list.
 *
 * i18next's navigator detector preferred an exact match anywhere in the list over a regional
 * match earlier in it, so ['sv-SE', 'en-US', 'en'] gave English, and Norwegian browsers that
 * report only 'nb'/'nn' (common on iOS) got English too. Here the first language whose base
 * code we support wins, with nb/nn read as Norwegian.
 */
const ALIASES: Record<string, string> = { nb: 'no', nn: 'no' };

export function pickLanguage(preferred: readonly string[], supported: readonly string[], fallback = 'en'): string {
  for (const tag of preferred) {
    const base = tag.toLowerCase().split(/[-_]/)[0]!;
    const code = ALIASES[base] ?? base;
    if (supported.includes(code)) return code;
  }
  return fallback;
}

/** A language the user chose in the app (saved by i18next), if it is still supported. */
export function storedLanguage(key: string, supported: readonly string[]): string | null {
  try {
    const v = localStorage.getItem(key);
    return v && supported.includes(v) ? v : null;
  } catch {
    return null;
  }
}
